import { render } from "./icon-no-access.svg?vue&type=template&id=1c3c5aa0&scoped=true&component"
const script = {}

import "./icon-no-access.svg?vue&type=style&index=0&id=1c3c5aa0&scoped=true&lang=css&component"

import exportComponent from "../../../../../../../node_modules/rspack-vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c3c5aa0"]])

export default __exports__